<template>
  <dd-drawer
      title="Notities"
      placement="right"
      :closable="true"
      v-bind="$attrs"
      @close="$emit('close')"
  >
    <PaginatedCategoryComponent
        @edit="(noteId) => editNote(noteId)"
        @view="(noteId) => viewNote(noteId)"
        ref="paginatedCategoryComponent"
        v-if="isCategoryPage || isInstancePage"
        :customer-id="customerId"
        :category-id="categoryId"
        :instance="instance"
    ></PaginatedCategoryComponent>
  </dd-drawer>
</template>

<script>
import PaginatedCategoryComponent from './PaginatedCategoryComponent.vue';
import { mapState, mapGetters, mapMutations } from "vuex";
import store from "./store";
export default {
  name: "NotesDrawer",
  components: {
    PaginatedCategoryComponent,
  },
  props: {
    publishDocuments: {
      type: Boolean,
      default: false,
    },
    showFilterOptions: {
      type: Boolean,
      default: true,
    },
    count: {
      type: Number,
      default: 0,
    }
  },
  beforeCreate() {
    const STORE_KEY = '$_notes_drawer'
    // eslint-disable-next-line no-underscore-dangle
    if (!(STORE_KEY in this.$store._modules.root._children)) {
      this.$store.registerModule(STORE_KEY, store)
    }
  },
  methods: {
    editNote(id) {
      this.setEditNoteId(id);
      this.setShowCreateNoteModal(true);
    },
    viewNote(id) {
      this.setViewNoteId(id);
      this.setShowViewNoteModal(true);
    },
    noCategoryOrInstanceFoundError() {
      throw new Error("Can't create note because there is no category or class instance provided for this page.");
    },
    onClose() {
      this.setEditNoteId(null);
      this.setShowCreateNoteModal(false);
    },
    onCloseNote() {
      this.setViewNoteId(null);
      this.setShowViewNoteModal(false);
    },
    onUpdated() {
      this.setShowCreateNoteModal(false);
      this.$refs.paginatedCategoryComponent.reloadPage();
    },
    onCreated() {
      this.setShowCreateNoteModal(false);
      this.$refs.paginatedCategoryComponent.reloadPage();
    },
    createNote() {
      this.setShowCreateNoteModal(true);
    },
    ...mapMutations(`$_customer_page`, {
      setShowCreateNoteModal: 'SET_SHOW_CREATE_NOTE_MODAL',
      setEditNoteId: 'SET_EDIT_NOTE_ID',
      setShowViewNoteModal: 'SET_SHOW_VIEW_NOTE_MODAL',
      setViewNoteId: 'SET_VIEW_NOTE_ID',
    })
  },
  emits: ['close'],
  computed: {
    ...mapState(`$_customer_page`, {
      customerId: 'customerId',
    }),
    ...mapState({
      instance: 'instance',
      categoryId: 'category_id',
    }),
    ...mapGetters({
      isInstancePage: 'isInstancePage',
      isCategoryPage: 'isCategoryPage',
    })
  },
};
</script>

<style lang="scss" scoped>
@import "~@/_default.scss";
</style>
